import styled from "styled-components";
export const HeaderComp = styled.header`
  background-color: ${(props) => props.theme.colors.primary};
  color: white;
  padding: 5px;
  text-align: center;
  font-size: 2rem;
  font-weight: bold;
  height:50px;
  border-bottom:1px solid #21202045;
`;
export const LogoText = styled.span`
margin-left:30px;
position:fixed;
// font-family: Mars Centra;
font-size: 18px;
font-weight: 500;
line-height: 50px;
text-align: center;
text-underline-position: from-font;
text-decoration-skip-ink: none;

`;
export const ActionText = styled.span`
vertical-align:top;
position:relative;
top:10px;
font-size: 12px;
// font-weight: bold;
color:#fff;  /* Choose a color for your logo text */
padding:10px;
// font-family: Mars Centra;
// font-size: 18px;
font-weight: 400;
// line-height: 23.4px;
// text-align: left;
text-underline-position: from-font;
text-decoration-skip-ink: none;

`
export const LabelText = styled.span`
font-size: large;
font-weight: bold;
color: ${(props) => props.theme.colors.primary};;  /* Choose a color for your logo text */
padding-right:10px;
`
